import { createContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { set_error, clear_error } from "../../App/actions/errorActions";

// Buat context
export const ErrorContext = createContext();

// Buat provider
export const ErrorProvider = ({ children }) => {
  const dispatch = useDispatch();
  const error = useSelector((state) => state.message);

  // Fungsi untuk menangani error
  const handleError = (func) => {
    return async (...args) => {
      try {
        await func(...args);
        // setTimeout(() => {
        //   dispatch(clear_error());
        // }, 0);
      } catch (error) {
        console.error("ErrorContext caught an error: ", error);
        dispatch(set_error(error));
        return;
      }
    };
  };

  // Fungsi untuk mereset error
  const clearError = () => {
    dispatch(clear_error());
  };

  return (
    <ErrorContext.Provider value={{ error, handleError, clearError }}>
      {children}
    </ErrorContext.Provider>
  );
};

// Implementasi menggunakan class component
/*

import { connect } from "react-redux";
import { set_error, clear_error } from "../../App/actions/errorActions";

// Buat context
export const ErrorContext = createContext();

// Buat provider sebagai class component
class ErrorProvider extends Component {
  constructor(props) {
    super(props);
    // Binding fungsi agar bisa digunakan di dalam class
    this.handleError = this.handleError.bind(this);
    this.clearError = this.clearError.bind(this);
  }

  // Fungsi untuk menangani error
  handleError(func) {
    return (...args) => {
      try {
        func(...args);
        this.props.clearError(); // Panggil action clear_error
      } catch (error) {
        console.error(error);
        this.props.setError({ message: error.message }); // Panggil action set_error
      }
    };
  }

  // Fungsi untuk mereset error
  clearError() {
    this.props.clearError(); // Panggil action clear_error
  }

  render() {
    const { error } = this.props; // Ambil error dari Redux state

    return (
      <ErrorContext.Provider
        value={{
          error,
          handleError: this.handleError,
          clearError: this.clearError,
        }}
      >
        {this.props.children}
      </ErrorContext.Provider>
    );
  }
}

// Map Redux state ke props
const mapStateToProps = (state) => ({
  error: state.message, // Ambil state error dari Redux
});

// Map Redux actions ke props
const mapDispatchToProps = {
  setError: set_error,
  clearError: clear_error,
};

// Hubungkan ErrorProvider dengan Redux
export default connect(mapStateToProps, mapDispatchToProps)(ErrorProvider);
*/
